import React from "react";
import styles from "./style.module.scss";
import cx from "classnames";

const LoadingPlaceholder = (props) => {
  const { isLoading, className } = props;

  return isLoading ? (
    <div className={cx([
      className,
      styles.loading_animation,
      styles.heading_loading
    ])}></div>) : props.children;
}

export default LoadingPlaceholder;